var fn_img_random = function () {
    var imgList = [];
    var imgContainer = $('.block-big-txt-img--img');
    var count = $('.block-big-txt-img--img').attr('data-count');

    for (var i = 0; i < count; i++) {
        imgList.push(imgContainer.attr('data-random-img-' + i));
    };

    if (count == 1){
        var id = 0;
    } else{
        var id = Math.floor(Math.random() * count);
        if(localStorage.getItem("hpImgBufferId")!=undefined){
            while (id == localStorage.getItem("hpImgBufferId")){
                id = Math.floor(Math.random() * count);
            };
        };
    }
    
    localStorage.setItem('hpImgBufferId', id);
    imgContainer.children('img').attr('src', imgList[id]);

}